import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../../redux/slices/authSlice';
import SignIn from './../../components/Auth/SignIn';

const SignInPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      navigate('/dashboard');
    }
  }, [token, navigate]);

  const handleSignIn = (event) => {
    event.preventDefault();
    const { username, password } = event.target.elements;

    // Dispatch the login action with email and password
    dispatch(login({ emailOrPhone: username.value, password: password.value }));
  };

  return (
    <div>
      <SignIn handleSignIn={handleSignIn} loading={loading} error={error} />
    </div>
  );
};

export default SignInPage;
